import * as Yup from  "yup";

export const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email('Email is not valid')
      .required('Email is required!'),
    // password: Yup.string()
    //   .matches(
    //       /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
    //       "The minimum password length is 8 characters and must contain atleast 1 lowercase letter, 1 capital letter, 1 number, and 1 special character"
    //   )
    //   .required('Password is required!')
  })
